const text = (value) => String(value ?? "").trim();

export const normalizeClientContactOptions = (response) => {
  const contacts = Array.isArray(response?.data?.clientContacts)
    ? response.data.clientContacts
    : [];

  return contacts
    .filter((contact) => !contact?.mergedIntoContactId)
    .map((contact) => {
      const contactId = text(contact?.contactId);
      if (!contactId) return null;
      const name =
        text(contact?.name) ||
        [text(contact?.firstName), text(contact?.lastName)].filter(Boolean).join(" ") ||
        text(contact?.email) ||
        contactId;
      const email = text(contact?.email);

      return {
        ...contact,
        contactId,
        displayLabel: email && email.toLowerCase() !== name.toLowerCase()
          ? `${name} — ${email}`
          : name,
      };
    })
    .filter(Boolean);
};

export const getCustomerChangeValues = (customerId) => ({
  attachedCustomers: customerId ? [customerId] : [],
  clientContactId: "",
});

export const fetchClientContactOptions = async (customerId, fetchContacts) => {
  if (!customerId) return [];
  const response = await fetchContacts(customerId);
  if (!response) throw new Error("Client contacts request failed");
  return normalizeClientContactOptions(response);
};

export const getCustomerBusinessName = (customer) =>
  text(customer?.businessName) ||
  text(customer?.BusinessName) ||
  text(customer?.companyName) ||
  text(customer?.name) ||
  "this customer";

export const normalizeCreatedClientContact = (contact) => {
  if (!contact) return null;
  return normalizeClientContactOptions({
    data: {
      clientContacts: [{
        ...contact,
        contactId: contact.contactId ?? contact.id ?? contact.CustomerContactId,
      }],
    },
  })[0] || null;
};

export const withOptionalClientContact = (values) => ({
  ...values,
  clientContactId: text(values?.clientContactId) || null,
});
